
  import Vue from 'vue'
  import TenantsTable from '@/components/entities/tenant/TenantsTable.vue'
  import TenantCreateDialog from '@/components/entities/tenant/TenantCreateDialog.vue'
  import EntityFiltersCard from '@/components/filters/EntityFiltersCard.vue'
  
  import InfoCard from '@/components/misc/InfoCard.vue'

  import TenantService from '@/services/TenantService';
  import { extractErrorMessage } from '@/utils/Util'

  export default Vue.extend({
    name: 'TenantsView',

    components: {
      TenantsTable,
      InfoCard,
      TenantCreateDialog,
      EntityFiltersCard
    },
    data: () => ({
      tenants: [] as any,
      dataLoaded: false,
      dataError: false,
      alertText: "",
      alertType: "error",
      filters: {} as any,
      filtersConfig: [
        { attribute: 'name', always: true },
        { attribute: 'deleted', always: false },
        { attribute: 'createdAt', always: false }
      ]
    }),
    created() {
        this.updateTenants();
    },
    methods: {
      onTableReload() {
        this.updateTenants();
      },
      onTenantFiltersApply() {
        this.updateTenants();
      },
      onTenantItemRestore(item: any) {
        this.updateTenants();
      },
      onTenantCreation(tenant: any) {
        this.tenants.push(tenant);
        this.$root.$store.commit("setTenants", this.tenants);
      },
      onTenantItemDelete(item: any) {
        // On delete of a user item, remove it from the table list
        this.tenants.splice(this.tenants.findIndex((tenant: any) => tenant.uuid === item.uuid), 1);
        this.$root.$store.commit("setTenants", this.tenants);
      },
      onTenantItemUpdate(item: any) {
        this.tenants.splice(this.tenants.findIndex((tenant: any) => tenant.uuid === item.uuid), 1);
        this.tenants.push(item);
        this.$root.$store.commit("setTenants", this.tenants);
      },
      updateTenants() {
        this.tenants = [];
        this.dataLoaded = false;

        let params = {};

        Object.assign(params, this.filters);

        TenantService.getAllCollectionPages(params).then((tenants: any[]) => {
          this.dataLoaded = true;

          this.tenants = tenants;
        }).catch((err: any) => {
          console.log(err, err.response);  
          this.alertType = "error";
          this.alertText = this.$t('tenant.loadingError') + ' ' + extractErrorMessage(err);
          this.dataError = true;      
        });
      },
    },
    computed: {
      canCreate(): any {
        if (this.$root.$store.state.session.permissions.resources && 'tenants' in this.$root.$store.state.session.permissions.resources) {
          return this.$root.$store.state.session.permissions.resources['tenants'].includes('POST');
        } else {
          return false;
        }
      },
      lastCreatedAt(): any {
        let occurrences: any = {};
        let sum = 0;

        let pastDate = new Date();
        pastDate.setDate(pastDate.getDate()-7); 

        this.tenants.forEach((userObj: any) => {
          let _date = new Date(userObj.createdAt);
          if(_date >= pastDate) {
            let item = _date.getDate() + '-' + _date.getMonth();
            occurrences[item] = (occurrences[item] || 0) + 1;
            sum = sum + 1;
          }
        }, {});

        return sum;
      }
    }
  })
